import { defineStore } from "pinia";

import { decodeAttachmentText } from "@/utils/attachmentTextUtils";
import { getCompanyId } from "@/utils/userUtils";

import attachmentsApi from "@/services/api/attachmentsApi";

export const useAttachmentStore = defineStore("attachment", {
  state: () => ({
    companyId: getCompanyId(),
    attachments: [],
    storageMeta: {
      total_count: 0,
      total_size: 0,
      total_size_mb: 0,
    },
    pagination: {
      page: 1,
      pages: 1,
      series: [],
      next: null,
      prev: null,
      count: 0,
      limit: 40,
    },
    dataIsLoading: false,
  }),

  actions: {
    async readMarkdown(url, options) { return decodeAttachmentText(await attachmentsApi.readFile(url, options)); },

    async uploadAttachment(file, filename = file.name || "file.png") {
      const data = new FormData();
      data.append("file", file, filename);
      const response = await attachmentsApi.create(this.companyId, data, true);

      return response.data.result || response.data;
    },

    async fetchAttachments(params = {}) {
      this.dataIsLoading = true;

      try {
        const response = await attachmentsApi.index(
          this.companyId,
          params
        );

        this.attachments = response.data.result || [];
        this.storageMeta =
          response.data.storage_meta || this.storageMeta;

        const meta = response.data.pagination_meta;
        if (meta) {
          this.pagination = {
            page: meta.page,
            pages: meta.pages,
            series: meta.series,
            next: meta.next,
            prev: meta.prev,
            count: meta.count,
            limit: meta.limit,
          };
        }

        return this.attachments;
      } finally {
        this.dataIsLoading = false;
      }
    },

    async fetchAttachment(id) {
      this.dataIsLoading = true;

      try {
        const response = await attachmentsApi.show(this.companyId, id);
        return response.data.result;
      } finally {
        this.dataIsLoading = false;
      }
    },
  },
});
